<template>
  <Dialog :commonDialog="uDialog" :dialogWidth="dialogWidth">
    <template v-slot:title>
      <v-layout>
        <v-flex> Manage Service UOM </v-flex>
        <v-flex class="text-right">
          <v-btn small class="mx-4" v-on:click="createProductUnit">
            <span class="font-size-16 font-weight-600">Add Service UOM</span>
          </v-btn>
        </v-flex>
      </v-layout>
    </template>
    <template v-slot:body>
      <perfect-scrollbar
        :options="{ suppressScrollX: true }"
        class="scroll custom-box-top-inner-shadow"
        style="max-height: 90vh; position: relative"
      >
        <v-form
          ref="ticketCollecttionForm"
          v-model.trim="formValid"
          lazy-validation
          v-on:submit.stop.prevent="updateProductUnit"
        >
          <v-container class="py-0">
            <v-row class="py-0">
              <v-col md="12" class="py-0">
                <table class="width-100">
                  <tbody>
                    <tr v-for="(type, index) in unitList" :key="index">
                      <td>
                        <v-text-field
                          v-model.trim="type.text"
                          dense
                          filled
                          label="Service Unit"
                          solo
                          flat
                          class="px-4 py-2"
                          hide-details
                          :readonly="type.text == existUnit && existUnit"
                          :disabled="pageLoading"
                          :loading="pageLoading"
                          :rules="[
                            validateRules.required(type.text, 'Service Unit'),
                          ]"
                          color="cyan"
                        ></v-text-field>
                      </td>
                      <td width="50">
                        <v-tooltip top content-class="custom-top-tooltip">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-on:click="deleteProductUnit(index)"
                              color="deep-orange"
                              v-bind="attrs"
                              v-on="on"
                              :disabled="type.text == existUnit && existUnit"
                              >mdi-delete</v-icon
                            >
                          </template>
                          <span>Click here to delete</span>
                        </v-tooltip>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </perfect-scrollbar>
    </template>
    <template v-slot:action>
      <v-btn
        :disabled="pageLoading || !formValid"
        :loading="pageLoading"
        class="mx-2 custom-grey-border custom-bold-button white--text"
        color="cyan"
        v-on:click="updateProductUnit"
      >
        Save
      </v-btn>
      <v-btn
        :disabled="pageLoading"
        class="mx-2 custom-grey-border custom-bold-button"
        v-on:click="$emit('close-dialog', true)"
      >
        Close
      </v-btn>
    </template>
  </Dialog>
</template>
<script>
import Dialog from "@/view/pages/partials/Dialog.vue";
import { PATCH } from "@/core/services/store/request.module";
import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";
import ValidationMixin from "@/core/plugins/validation-mixin";
import CommonMixin from "@/core/plugins/common-mixin";
import { cloneDeep ,forEach} from "lodash";

export default {
  mixins: [ValidationMixin, CommonMixin],
  props: {
    uDialog: {
      type: Boolean,
      required: true,
      default: false,
    },
    existUnit: {
      type: String,
      default: null
    },
    unit: {
      type: Array,
      default: () => {
        return new Array();
      },
    },
  },
  watch: {
    unit: {
      deep: true,
      immediate: true,
      handler(param) {
        this.unitList = cloneDeep(param);
      },
    },
  },
  data: () => {
    return {
      formValid: true,
      pageLoading: false,
      unitList: [
        {
          text: null,
          type: 'service',
        },
      ],
    };
  },
  methods: {
    updateProductUnit() {
      const _this = this;

      const formErrors = _this.validateForm(_this.$refs.ticketCollecttionForm);

      if (formErrors.length) {
        for (let i = 0; i < formErrors.length; i++) {
          ErrorEventBus.$emit("update:error", InitializeError(formErrors[i]));
          _this.pageLoading = false;
        }
        return false;
      }
      forEach(this.unitList, (row) => {
             row.type =  'service'
            });
      _this.pageLoading = true;
      _this.$store
        .dispatch(PATCH, {
          url: "setting/product-unit",
          data: { product_unit: _this.unitList },
        })
        .then(() => {
          _this.$emit("close-dialog", true);
          _this.$emit("get-product-unit", true);
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
    createProductUnit() {
      this.unitList.push({
        text: null,
      });
    },
    deleteProductUnit(index) {
      if (this.unitList.length > 1) {
        this.unitList.splice(index, 1);
      }
    },
  },
  components: {
    Dialog,
  },
  computed: {
    dialogWidth() {
      return this.lodash.toSafeInteger((document.body.clientWidth / 100) * 50);
    },
  },
};
</script>
